<template>
  <div>
    <b-skeleton-wrapper :loading="isLoading">
      <template #loading>
        <div
          class="h-100 w-100 article-card position-relative"
          :class="{
            'overlay': isOverlayType,
          }"
        >
          <div class="image-holder mb-2">
            <b-skeleton-img no-aspect animation="fade" class="w-100 h-100" />
            <div v-if="isOverlayType" class="title-container w-100">
              <b-skeleton class="w-100 parent-title"/>
              <b-skeleton class="w-100 title mt-2"/>
            </div>
          </div>
          <div v-if="!isOverlayType">
            <b-skeleton class="w-100 parent-title mt-3"/>
            <b-skeleton class="w-100 title mt-2"/>
          </div>
        </div>
      </template>
      <div
        v-if="articleForCard !== null"
        class="h-100 w-100 article-card position-relative"
        :class="{
          'overlay': isOverlayType,
        }"
      >
        <favorite-button
          v-if="isLoggedIn && articleForCard.id !== null"
          :item-id="parseInt(articleForCard.id)"
          :item-type="'article'"
          :is-background-visible="true"
        />
        <router-link
          :to="articleForCard.url"
          :target="'target' in articleForCard ? articleForCard.target : '_self'"
        >
          <div class="image-holder mb-2">
            <b-img-lazy
              :src="articleForCard.imageSrc"
              :alt="articleForCard.title"
              class="w-100"
            />
            <div v-if="isOverlayType" class="title-container">
              <div
                v-if="articleForCard.parentTitle"
                v-text="articleForCard.parentTitle"
                class="parent-title"
              />
              <div
                v-text="articleForCard.title"
                class="title mt-2"
              />
            </div>
          </div>
          <div v-if="!isOverlayType">
            <div
              v-if="articleForCard.parentTitle"
              v-text="articleForCard.parentTitle"
              class="parent-title"
            />
            <div
              v-text="articleForCard.title"
              class="title mt-2"
            />
          </div>
        </router-link>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import Axios from 'axios'
import { BImgLazy, BSkeleton, BSkeletonImg, BSkeletonWrapper } from 'bootstrap-vue'

export default {
  name: 'ArticleCard',
  components: {
    'favorite-button': () => import(/* webpackChunkName: "favoriteButton" */ '../favoriteButton/favoriteButton.vue'),
    'b-img-lazy': BImgLazy,
    'b-skeleton-wrapper': BSkeletonWrapper,
    'b-skeleton-img': BSkeletonImg,
    'b-skeleton': BSkeleton,
  },
  props: {
    /**
     * adatok lekérése folyamatban van-e (kell-e skeleton loader)
     */
    isLoading: {
      type: Boolean,
      default: false,
    },
    /**
     * cikk object amit meg akarunk jeleniteni
     *
     * @type {{
     *   id: Number,
     *   title: String,
     *   parentTitle: String|null,
     *   imageSrc: String,
     *   url: String,
     * }}
     */
    article: {
      type: Object,
      default: null,
    },
    /**
     * cikk id amit megakarunk jeleniteni
     */
    articleId: {
      type: Number,
      default: null,
    },
    /**
     * overlay és mobil állitott stilusu kártya-e
     */
    isOverlayType: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      /**
       * cikk object amit meg akarunk jeleniteni
       * ha cikk objectumot kapunk akkor az kerül bele, ha Id-t akkor lekérjük az adatokat és az kerül ebbe
       *
       * @type {{
       *   id: Number,
       *   title: String,
       *   parentTitle: String|null,
       *   imageSrc: String,
       *   url: String,
       * }}
       */
      articleForCard: null,
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'User/isLoggedIn',
    }),
  },
  created() {
    if (this.articleId !== null) {
      this.loadArticle()
    } else if (this.article !== null) {
      this.articleForCard = this.article
    }
  },
  methods: {
    /**
     * cikk betöltése Id alapján
     */
    loadArticle() {
      Axios.get('Article/api/getArticleDataForCard', {
        params: {
          id: this.articleId,
        },
      })
      .then(({ data }) => {
        this.articleForCard = data
      })
    },
  },
}
</script>

<style scoped lang="scss">
.favorite-btn {
  top: 15px;
  right: 30px;
}

.article-card {
  a {
    color: #111;
  }
}

.overlay {
  @media screen and (max-width: 576px) {
    height: 130vw;
  }

  .title-container {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 1rem;
    z-index: 1;

    .parent-title {
      color: #fff;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;

      @media screen and (max-width: 991px) {
        font-size: 12px;
        line-height: 16px;
      }
    }

    .title {
      color: #fff;
      font-weight: 800;
      font-size: 24px;
      line-height: 30px;
      max-height: 90px;
      overflow-y: hidden;

      @media screen and (max-width: 991px) {
        font-size: 18px;
        line-height: 24px;
        max-height: 72px;
      }
    }
  }

  .image-holder {
    height: 100%;

    &::after {
      content: "";
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
      height: 100%;
      left: 0;
      overflow: hidden;
      position: absolute;
      bottom: 0;
      width: 100%;
    }

    img {
      object-fit: cover;
    }
  }
}

.image-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 375px;
  position: relative;

  img {
    height: 100%;
    object-fit: contain;
  }

  ::v-deep .b-skeleton-img {
    width: 100%;
    min-height: 420px;
  }
}

.parent-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;

  @media screen and (max-width: 991px) {
    font-size: 12px;
    line-height: 14px;
  }
}

.title {
  font-weight: 800;
  font-size: 18px;
  line-height: 24px;

  @media screen and (max-width: 991px) {
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
